module.exports = __webpack_public_path__ + "@/assets/img/02.f4931634.svg";